import { render, staticRenderFns } from "./TableBudgetSimple.vue?vue&type=template&id=3106e49a&scoped=true"
import script from "./TableBudgetSimple.vue?vue&type=script&lang=js"
export * from "./TableBudgetSimple.vue?vue&type=script&lang=js"
import style0 from "./TableBudgetSimple.vue?vue&type=style&index=0&id=3106e49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106e49a",
  null
  
)

export default component.exports